
export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  category: string;
  content?: string;
}

export const blogPosts: BlogPost[] = [
  {
    id: "natural-hair-care-tips",
    title: "5 Essential Tips for Natural Hair Care",
    excerpt: "Discover our top tips for maintaining healthy natural hair with simple daily routines and natural ingredients.",
    image: "/lovable-uploads/2166a74e-a4a3-42b7-8260-7dc533841a25.webp",
    date: "April 8, 2025",
    category: "Hair Care",
    content: `
      <h2>Embrace Your Natural Texture</h2>
      <p>The first step to healthy natural hair is embracing its unique texture. Every curl, coil, and wave is beautiful in its own way. Avoid comparing your hair to others or trying to force it into styles that require excessive heat or chemical treatments.</p>
      
      <h2>Hydration is Key</h2>
      <p>Natural hair tends to be drier than other hair types because the natural oils from your scalp take longer to travel down curly or coily strands. Deep condition your hair regularly with moisturizing treatments that contain natural ingredients like shea butter, coconut oil, or aloe vera.</p>
      
      <h2>Protective Styling</h2>
      <p>Giving your hair a break from daily manipulation can make a huge difference in its health. Try protective styles like twists, braids, or buns that keep your ends tucked away and protected from environmental damage.</p>
      
      <h2>Gentle Detangling</h2>
      <p>Always start detangling from the ends and work your way up to the roots. Use a wide-tooth comb or your fingers, and only detangle when your hair is wet and has conditioner in it to minimize breakage.</p>
      
      <h2>Nighttime Protection</h2>
      <p>Sleep with a satin or silk bonnet, or use a satin pillowcase. Cotton pillowcases can absorb moisture from your hair and cause friction that leads to breakage and frizz.</p>
    `
  },
  {
    id: "skin-hydration-guide",
    title: "The Complete Guide to Skin Hydration",
    excerpt: "Learn how to keep your skin naturally hydrated throughout the changing seasons with our expert advice.",
    image: "/lovable-uploads/9b379c65-a1ff-4960-b5b2-a6b8d4edae03.webp",
    date: "April 5, 2025",
    category: "Skin Care",
    content: `
      <h2>Understanding Hydration vs. Moisturization</h2>
      <p>Hydration refers to the water content within your skin cells, while moisturization is about sealing that hydration in. For truly healthy skin, you need both: water-based products to hydrate and oil-based products to moisturize.</p>
      
      <h2>Layer Your Products Correctly</h2>
      <p>The order of application matters tremendously. Start with the thinnest, most water-based products and work your way up to heavier, oil-based products. A typical routine might include: cleanser, toner, essence or serum, moisturizer, and then oil or sunscreen.</p>
      
      <h2>Hyaluronic Acid: Your Hydration Hero</h2>
      <p>Hyaluronic acid can hold up to 1000 times its weight in water, making it an incredible ingredient for boosting skin hydration. Look for products containing different molecular weights of hyaluronic acid for deeper penetration.</p>
      
      <h2>Seasonal Adjustments</h2>
      <p>Your skin's hydration needs change with the seasons. In winter, you might need richer products and humidifiers to combat indoor heating. In summer, lighter hydrating layers might be sufficient, but never skip moisturizer entirely.</p>
      
      <h2>Hydration From Within</h2>
      <p>No skincare routine can compensate for dehydration. Aim to drink at least 8 glasses of water daily, and incorporate hydrating foods like cucumbers, watermelon, and leafy greens into your diet.</p>
    `
  },
  {
    id: "ingredients-to-avoid",
    title: "Top Ingredients to Avoid in Beauty Products",
    excerpt: "Understanding product labels and identifying potentially harmful ingredients in your beauty products.",
    image: "/lovable-uploads/daca4a7e-6d2f-4279-b773-368b4eaa56e8.webp",
    date: "April 1, 2025",
    category: "Wellness",
    content: `
      <h2>Parabens: The Controversial Preservatives</h2>
      <p>Parabens are commonly used preservatives in cosmetics that prevent the growth of bacteria and mold. However, they've been linked to hormone disruption as they can mimic estrogen in the body. Look for ingredients ending in -paraben (methylparaben, propylparaben, butylparaben, etc.) on labels.</p>
      
      <h2>Synthetic Fragrances: Hidden Chemicals</h2>
      <p>When you see "fragrance" or "parfum" on a label, it could represent a proprietary blend of dozens or even hundreds of chemicals. Companies aren't required to disclose these ingredients, and they're common allergens and irritants. Opt for products that use essential oils or are fragrance-free.</p>
      
      <h2>Sulfates: Harsh Cleansers</h2>
      <p>Sodium Lauryl Sulfate (SLS) and Sodium Laureth Sulfate (SLES) are foaming agents that can strip the skin and hair of natural oils, leading to dryness and irritation. They're particularly problematic for those with sensitive skin or curly/dry hair.</p>
      
      <h2>Formaldehyde and Formaldehyde Releasers</h2>
      <p>Formaldehyde is a known carcinogen, but it's still found in some beauty products or released by preservatives like DMDM hydantoin, diazolidinyl urea, imidazolidinyl urea, and quaternium-15. These can cause skin irritation and are potentially harmful with long-term exposure.</p>
      
      <h2>Phthalates: Plastic Softeners</h2>
      <p>Often hidden under "fragrance" on labels, phthalates are used to make plastics more flexible and help fragrances last longer. They've been linked to endocrine disruption and reproductive issues. Look specifically for "phthalate-free" products as they might not be listed explicitly.</p>
    `
  }
];
